export const messages = {
    defaultSuccessMessage: 'Success!',
    defaultErrorMessage: 'Oops! Something went wrong!',
    defaultActionErrorMessage: 'Permission Denied! You do not have proper permission',
    defaultNextSaved: 'Saved Successfully!'
}